<template>

    <div class="d-flex flex-wrap justify-content-center mx--8px">
        <DonationOption v-for="(amount, index) in amounts"
            :key="`${amount.value}-${index}`"
            :data="amount"
            @selected="$emit('selected',$event)"/>

        <DonationCustomOption
            v-if="customAmount"
            :data="customAmount"
            @selected="$emit('selected',$event)"/>
    </div>

</template>

<script>

    import {mapGetters} from "vuex";
    import DonationOption from '@/components/donations/DonationOption';
    import DonationCustomOption from '@/components/donations/DonationCustomOption';

    export default {
        name: 'DonationOptions',
        components: {DonationOption,DonationCustomOption},

        computed: {
            ...mapGetters('Donations', {
                amounts: 'donationAmounts',
                customAmount: 'donationCustomAmount'
            }),
        }
    }

</script>
